import {RouterProps} from "../../../RouterProps";
import {useStatePair} from "react-type-extension";
import {UserBlockReasonSearchOption} from "../../../../data/search-option/user/UserBlockReasonSearchOption";
import {SearchIndex} from "../../../../io/HttpClient";
import {SortOrder} from "ts-protocol-extension";
import ListPageWrapper from "../../../ListPageWrapper";
import {UserBlockReasonIO} from "../../../../io/UserIO";
import {UserBlockReasonDescription} from "../../../../data/description/user/UserBlockReasonDescription";
import {UserBlockReasonDescriptor} from "../../../../data/descriptor/user/UserBlockReasonDescriptor";
import ListOption from "../../../ListOption";
import {UserBlockReasonSearchOptionDescription} from "../../../../data/description/user/UserBlockReasonSearchOptionDescription";
import {applyUserBlockReasonSearchOption, UserBlockReasonSearchOptionField} from "../../../search-option-field/user/UserBlockReasonSearchOptionField";
import ListOrder from "../../../ListOrder";
import {UserBlockReasonValueObject} from "../../../../data/value-object/user/UserBlockReasonValueObject";

enum Phase {
    List,
    Option,
    Order
}

export default function List(props: RouterProps) {
    const phase = useStatePair<Phase>(Phase.List)
    const items = useStatePair<UserBlockReasonValueObject[]>([])
    const option = useStatePair<UserBlockReasonSearchOption>({})
    const index = useStatePair<SearchIndex>({ pageIndex: 0n, sortOrder: [SortOrder.ASC], sortPriority: ['id'] })

    return <>
        {phase.value === Phase.List && <>
            <ListPageWrapper
                {...props}
                client={UserBlockReasonIO}
                items={items}
                option={option.value}
                index={index}
                description={UserBlockReasonDescription}
                descriptor={UserBlockReasonDescriptor}
                showPost
                onPostClick={() => document.location = '/users/blocks/reasons/post'}
                showFilter
                onFilterClick={() => phase.setter(Phase.Option)}
                showSort
                onSortClick={() => phase.setter(Phase.Order)}
                onItemClick={item => document.location = `/users/blocks/reasons/${item.id}`}/>
        </>}
        {phase.value === Phase.Option && <>
            <ListOption
                {...props}
                option={option.value}
                description={UserBlockReasonSearchOptionDescription}
                fields={UserBlockReasonSearchOptionField}
                onBackClick={() => phase.setter(Phase.List)}
                onApplyClick={(key, value) => {
                    applyUserBlockReasonSearchOption(key, value, option)
                    index.setter({ ...index.value, pageIndex: 0n })
                    items.setter([])
                }}
                onDismissClick={key => {
                    const next = { ...option.value }
                    next[key] = undefined
                    option.setter(next)
                    items.setter([])
                }} />
        </>}
        {phase.value === Phase.Order && <>
            <ListOrder
                {...props}
                index={index}
                description={UserBlockReasonDescription}
                onBackClick={() => phase.setter(Phase.List)}
                onOrderUpdated={() => items.setter([])} />
        </>}
    </>
}